export function TopSection() {
  return (
    <div className="top-section" id="topSection">
      <div className="header">
        <h1>Data Plotter</h1>
        <p>
          Scientific plots for manuscripts and slides—no code. Drop a data file, choose columns, and customize. Export as PNG,
          JPEG, or PDF.
        </p>
        <p className="privacy-notice">
          <strong>Privacy:</strong> Everything runs in your browser. Your data is never uploaded or stored. Max file size 1 GB.
        </p>
      </div>
      <div className="supported-section">
        <h2>Supported formats</h2>
        <ul className="supported-list">
          <li>
            <strong>Text / CSV</strong> (<code>.txt</code>, <code>.dat</code>) — Delimited columns; optional header row. Choose X
            and Y columns, then plot as line, scatter, or bar (with optional y-error bars).
          </li>
          <li>
            <strong>ROOT</strong> (<code>.root</code>) — 1D/2D/3D histograms (TH1, TH2, TH3), profiles (TProfile), graphs
            (TGraph), and functions (TF1). TH2 as heatmap, TH3 as 3D scatter. Open one or several files, browse the tree, add
            objects, optionally normalize or stack.
          </li>
          <li>
            <strong>Configuration</strong> (<code>.json</code>) — Load a saved plot configuration (column choices, axis labels,
            style). Then load a data file to apply it.
          </li>
        </ul>
      </div>
      <div className="upload" id="dropZone">
        <div className="upload-inner">
          <span className="fa fa-cloud-upload" />
          <p>
            <strong>Drop a data file here</strong> or{' '}
            <button type="button" className="browse" id="browseBtn">
              Browse
            </button>
          </p>
          <p className="hint" id="uploadHint">
            Accepted: .txt, .dat, .root, .json — Max size: 1 GB
          </p>
        </div>
      </div>
      <div className="message" id="message" aria-live="polite" />
    </div>
  );
}
